import { VIEW_MODE_ICONS } from '@lumapps/designer-widget-settings/constants';
import { ViewModeType } from '@lumapps/designer-widget-settings/types';
import { WIDGET_BASE } from '@lumapps/widget-base/keys';

/**
 * Define all global constants for the package
 * */

export const WIDGET_LEARNING_CATALOG_TYPE = 'learning-catalog'; // Name of the widget as saved in the layout within widgetType.

export const DATA_SCOPE = 'learning-catalog';

export enum VIEW_MODE_VARIANTS_VALUES {
    GROUPED = 'grouped',
    UNGROUPED = 'ungrouped',
}

export const VIEW_MODE_LIST_VARIANTS: ViewModeType<string>[] = [
    {
        label: WIDGET_BASE.SETTINGS_VIEW_MODE_GROUPED,
        value: VIEW_MODE_VARIANTS_VALUES.GROUPED,
        icon: VIEW_MODE_ICONS.LIST_GROUP,
    },
    {
        label: WIDGET_BASE.SETTINGS_VIEW_MODE_UNGROUPED,
        value: VIEW_MODE_VARIANTS_VALUES.UNGROUPED,
        icon: VIEW_MODE_ICONS.LIST_UNGROUP,
    },
];
